"use client";

import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardImg, Container, Row, Col, CardImgOverlay, CardFooter, CardTitle } from 'reactstrap';
import Image from 'next/image';
import Visitation from '@/components/Visitation/Visitation';
import styles from './layout.module.scss';
import LinkCard from '@/components/LinkCard/LinkCard';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";


const HomePage: React.FC = () => {
  const [signinEnabled, setSigninEnabled] = useState(true);

  useEffect(() => {
    fetch('/api/config')
      .then((res) => res.json())
      .then((data) => setSigninEnabled(data.enableSignin))
      .catch(() => setSigninEnabled(false));
  }, []);

  const Overview: React.FC = () => {
    return (
      <section className="container" style={{ maxWidth: "1152px" }}>


        <Row style={{ maxWidth: "58rem", margin: "0 auto 2.3rem" }} >
          <p className="text-center" style={{ color: "#444444", fontSize: "20px", lineHeight: 1.6, fontWeight: 500 }}>
            UnitedHealth Premium® evaluates physicians for quality of care, efficiency of care and cost of care.
            <br />
            The Premium Care designation is displayed in commercial provider directories and may be
            <br />
            used by members to help make more informed choices for their medical care. Physicians may also
            <br />
            use their evaluation details to support their efforts to provide quality care to their patients.
          </p>
        </Row>
        <Col className=" d-flex  flex-row gap-0 equal-card-size" >
          <LinkCard
            to="/secure"
            title="My Designation(s)"
            linkText="Sign in to access and review designation details"
            icon={faChevronRight}
            disabled={!signinEnabled}
          >
            <span className={styles["image-wrapper"]}>
              <img width={77} height={68}
                src={'/Images/icon-program-method.png'}
                alt="Program Methodology Icon"
                className="center-block program-icon"
              />
            </span>
          </LinkCard>

          <LinkCard
            to="/premium-methodology"
            title="Premium Methodology"
            linkText="Read Program Methodology"
            icon={faChevronRight}
          >
            <span className={styles["image-wrapper"]}>
              <img width={51} height={64}
                src={'/Images/icon-signin.png'}
                alt="Sign In Icon"
                className="center-block signin-icon"
              />
            </span>
          </LinkCard>
          <LinkCard
            to="https://chameleon-4-prod.s3.amazonaws.com/clients/39-64ecae4085df9/courses/4383-671f904b8a943/prod/index.html"
            title="Reconsideration"
            linkText="Go to Reconsideration Materials"
            icon={faChevronRight}
          >
            <span className={styles["image-wrapper"]}>
              <img width={69} height={94}
                src={'/Images/icon-training.png'}
                alt="Reconsideration Icon"
                className="center-block training-icon"
              />
            </span>
          </LinkCard>

        </Col>

      </section>
    );
  };

  return (
    <div>
      <Visitation type="home">
        <div className={styles['header-container']}>
          <h1 className={styles['header-title']}>
            UnitedHealth Premium®
          </h1>
        </div>
      </Visitation>
      <Container style={{ padding: 50 }}>
        <Overview />
      </Container>
    </div>
  );
};

export default HomePage;
